
var tabTitles = document.querySelectorAll('.collecitons_tab_title');
var tabs_section__id = document.querySelector('.tabs_collection_conatiner')?.getAttribute("data-id");
 
function setActiveTab() {
  const activeTabUrl = window.activeTabUrl;  
  if (activeTabUrl) {
    tabTitles.forEach(tab => {
      tab.classList.remove('tab_title_active');  
      if (tab.getAttribute('data-url') === activeTabUrl) {
        tab.classList.add('tab_title_active');  
      }
    });
  }
}

   if(tabs_section__id){ 
  tabTitles.forEach(tabTitle => {
      tabTitle.addEventListener('click', function() {        
          window.activeTabUrl = this.getAttribute('data-url'); 
          const dataUrl = this.getAttribute("data-url");       
        fetch(dataUrl + `?sections=${tabs_section__id}`)
              .then(response => {
                  if (!response.ok) throw new Error('Network response was not ok');
                  return response.json();
              })
              .then(htmlText => {
               const doc = new DOMParser().parseFromString(htmlText[`${tabs_section__id}`], "text/html");
               const updatedSection = doc.querySelector("slider-component").outerHTML;
               
              if (updatedSection) {
                document.querySelector(`#shopify-section-${tabs_section__id} slider-component`).outerHTML = updatedSection;
                HTMLUpdateUtility.setInnerHTML(document.querySelector(`#shopify-section-${tabs_section__id}`), doc.querySelector(`#shopify-section-${tabs_section__id}`).outerHTML);
                setTimeout(setActiveTab, 200) ;
              } else {
                console.error("Product grid not found.");
              }
               })
              .catch(error => console.error('Error fetching data:', error.message));
      });
  });
}
  document.querySelector('header-drawer details').addEventListener('toggle', (e) => {
    document.querySelector('.template_index .header .header__icon--account').classList.toggle("hidden");
    document.querySelector('.template_index .header .header__icons').classList.toggle("hidden");
   
});

//  document.addEventListener('DOMContentLoaded', function () {
//   const grid = document.querySelector('.product-grid');
//   if (!grid) return;

//   const observer = new MutationObserver(function (mutations) {
//     mutations.forEach(function (mutation) {
//       if (mutation.addedNodes.length > 0 && window.Trustpilot) {

//         grid.querySelectorAll('.trustpilot-widget').forEach(function (el) {
//           if (!el.dataset.tpLoaded) {
//             window.Trustpilot.loadFromElement(el, true);
//             el.dataset.tpLoaded = 'true';
//           }
//         });

//       }
//     });
//   });

//   observer.observe(grid, {
//     childList: true,
//     subtree: true
//   });
// });

 

 